import React, { useState } from 'react';
import { ModalCompontent } from '../../Shared/Scripts/Components/ModalComponent';
import { ArticleContentComponent } from '../../Shared/Scripts/Components/ArticleContentComponent';

interface ModalVinduProps {
    tittel: string,
    brodtekst: { value: string; },
    visModalLenkeTekst: string,
    lukkModalLenkeTekst: string,
    cssClass: string
}

export default function ModalVindu(props: ModalVinduProps): JSX.Element {
    const [visModal, setVisModal] = useState(false);

    function onClickVisModal(): void {
        setVisModal(true);
    }

    function onClickLukkModal(): void {
        setVisModal(false);
    }
    
    return (
            <div>
                <button type="button" className={props.cssClass} onClick={onClickVisModal}>
                    {props.visModalLenkeTekst}
                </button>
                <ModalCompontent
                    isOpen={visModal}
                    onRequestClose={onClickLukkModal}
                    ariaCloseText={props.lukkModalLenkeTekst}
                >
                    <ArticleContentComponent
                        headerinnhold={<span dangerouslySetInnerHTML={{__html: props.tittel}} />}
                        contentinnhold={<div dangerouslySetInnerHTML={{__html: props.brodtekst.value}} />}
                    />
                </ModalCompontent>
            </div>
    );
}
